// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/EmbedYouTubeVideo/EmbedYouTubeVideo.css
// module id = 974
// module chunks = 0